import { render } from "./HelpCenterRequestSection.vue?vue&type=template&id=344b126e&scoped=true&ts=true"
import script from "./HelpCenterRequestSection.vue?vue&type=script&lang=ts"
export * from "./HelpCenterRequestSection.vue?vue&type=script&lang=ts"

import "./HelpCenterRequestSection.vue?vue&type=style&index=0&id=344b126e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344b126e"]])

export default __exports__